import React from 'react';
interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'success' | 'warning' | 'error' | 'info' | 'neutral';
  size?: 'sm' | 'md';
  showDot?: boolean;
  className?: string;
}
export const Badge: React.FC<BadgeProps> = ({
  children,
  variant = 'default',
  size = 'md',
  showDot = false,
  className = ''
}) => {
  const variants = {
    default: 'bg-surface-secondary text-text-secondary border border-border-light',
    success: 'bg-status-success-bg text-status-success border border-status-success/20',
    warning: 'bg-status-warning-bg text-status-warning border border-status-warning/20',
    error: 'bg-status-error-bg text-status-error border border-status-error/20',
    info: 'bg-status-info-bg text-status-info border border-status-info/20',
    neutral: 'bg-gray-100 text-gray-700 border border-gray-200'
  };
  const dotColors = {
    default: 'bg-text-secondary',
    success: 'bg-status-success',
    warning: 'bg-status-warning',
    error: 'bg-status-error',
    info: 'bg-status-info',
    neutral: 'bg-gray-500'
  };
  const sizes = {
    sm: 'text-[10px] px-1.5 py-0.5',
    md: 'text-xs px-2.5 py-0.5'
  };
  return <span className={`inline-flex items-center font-medium rounded-full ${variants[variant]} ${sizes[size]} ${className}`} data-id="element-154">
      {showDot && <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${dotColors[variant]}`} aria-hidden="true" data-id="element-155" />}
      {children}
    </span>;
};